import { Link } from "react-router-dom";
import { Col, Row, Image } from "react-bootstrap";
import { useContext } from "react";
import { PropContext } from "../layout/PropContext";
import List from "../format/List";
import { checkURL } from "../util/api.mjs";

export default function MoviesTV() {
  const { assets } = useContext(PropContext);

  checkURL(assets.origin);
  if (assets.origin !== "movies_tv") return "...Loading";

  for (const key of Object.keys(assets.items)) {
    if (!Object.keys(assets.comments).some((comment) => comment === key))
      console.error(`Improperly matched key, assets/movies_tv, ${key}`);
    assets.items[key] = { ...assets.items[key], comment: assets.comments[key] };
  }

  return (
    <>
      <Row>
        <p name="page description" id="page_description">
          To be honest I don't watch much TV and movies have fallen to the
          wayside as well. When I do watch things it tends to be more out of
          nostalgia than anything else. Anyway here are a few TV shows and
          movies I enjoy. Clicking the movie/show will open a new tab to its
          TMDB page.
        </p>
      </Row>
      <Row>
        <List listName="movies_tv" itemType="card" items={assets.items} />
      </Row>
      <Row style={{ margin: "1rem 0 0 0", padding: "1rem 0" }}>
        <Col name="TMDB acknowledgement" className="movies-tv-tmdb-container">
          <p>
            "This website uses TMDB and the TMDB APIs but is not endorsed,
            certified, or otherwise approved by TMDB."
          </p>
          <Link to="https://www.themoviedb.org/" target="_blank">
            <Image
              src={assets.tmdb_logo}
              fluid
              className="movies-tv-tmdb-image"
            />
          </Link>
        </Col>
      </Row>
    </>
  );
}
